/**
 * Created by Andrey Popov on 9/19/25.
 */

const UnitsForFogsCopyHandler = function () {
};

UnitsForFogsCopyHandler.prototype.isApplicable = function () {
    const map = Map2d.currentMap;
    return map && map.selection && map.selection.hasSelectedUnits();
};

UnitsForFogsCopyHandler.prototype.copy = function () {
    const map = Map2d.currentMap;
    const location = cleverapps.meta.getSelectedLocation().locationId;

    const positionToFogMap = {};
    for (const fogName in map.regions) {
        const region = map.regions[fogName];
        for (let i = 0; i < region.positions.length; i++) {
            const p = region.positions[i];
            positionToFogMap[Unit.GetPositionKey(p)] = fogName.replace(location, "{location}");
        }
    }

    const units = map.selection.getSelectedUnits().map((u) => {
        const fog = positionToFogMap[Unit.GetPositionKey(u)];
        const region = fog && map.regions[fog];
        const isHead = region && region.head && Unit.GetPositionKey(region.head) === Unit.GetPositionKey(u);
        const lock = u.findComponent(LockedComponent) && u.findComponent(LockedComponent).isLockActive() ? 1 : undefined;

        return {
            code: u.code,
            stage: u.stage,
            lock,
            x: u.x,
            y: u.y,
            fog,
            isHead
        };
    });

    const meta = { type: "UnitsForFogs", location };
    const data = units;
    return JSON.stringify({
        meta,
        data
    }, null, 4);
};

ClipboardService.REGISTERED_COPY_HANDLERS.push(UnitsForFogsCopyHandler);